import BlogTags from ".";



export const blogTagsRoutes = () => [
  {
    path:"/admin/blog-tags",
    component: BlogTags,
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
];
